import { useEffect } from "react";

const APP_LINK = "digitail://ClinicProfile/vetdigitails";

function ensureNoIndexMeta() {
  let meta = document.querySelector(
    'meta[name="robots"]',
  ) as HTMLMetaElement | null;
  const created = !meta;
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "robots";
    document.head.appendChild(meta);
  }
  const previous = meta.content;
  meta.content = "noindex, nofollow";
  return { meta, previous, created };
}

export function DigitailPage() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Digitail";

    const { meta, previous, created } = ensureNoIndexMeta();

    return () => {
      document.title = prevTitle;
      if (created) {
        meta.remove();
      } else {
        meta.content = previous;
      }
    };
  }, []);

  return (
    <main className="content" style={{ paddingTop: 80, textAlign: "center" }}>
      <h1 style={{ marginBottom: 12 }}>Digitail</h1>
      <p style={{ color: "#9aa8c7", margin: "0 0 18px" }}>
        Open the clinic profile in the app:
      </p>
      <a
        href={APP_LINK}
        className="button button-primary"
        style={{ display: "inline-flex" }}
      >
        Open in Digitail
      </a>
      <br />
      <span>digitail://ClinicProfile/vetdigitails</span>
      <p style={{ color: "#9aa8c7", marginTop: 18, fontSize: 13 }}>
        If nothing happens, make sure the Digitail app is installed.
      </p>
    </main>
  );
}
